var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide","mode":"out-in","type":"animation"}},[_c('v-container',{attrs:{"fill-height":"","grid-list-lg":"","wrap":""}},[_c(_vm.shownComponent,{tag:"component",attrs:{"content":_vm.content}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }